export default function insertAfter(target, source) {
    try {
        return target.parentElement.insertBefore(source, target.nextSibling);
    } catch (error) {
        return error;
    }
}
